import { Button, Grid } from "@material-ui/core";
import CircularLoader from "../../../../../components/loading/circularLoader";
import { Print } from "@material-ui/icons";
import moment from "moment";
import { useContext, useState } from "react";
import { QueryParamsContext } from "../../../../../context/QueryParamsContext";
import { printServiceContractPDF } from "../../../../../repositories/qerpapi/erp/relatorio/ContratosServicoRepository";
import { b64toBlob } from "../../../../../utils/file64toBlob";
import { notify } from "../../../../../utils/notify";
import {
  contractStatus,
  contractsColumns,
  dateType,
  groupment,
  modality,
  contractPeriod as periods,
} from "../../../constants";
import { useContratoServicoService } from "../../context/ContratoServicoContext";
import ExportButton from "../ExportButton";

export const ReportActions = () => {
  const [printLoading, setPrintLoading] = useState(false);
  const { cachedContracts, filters, cachedCompanies, cachedClients, columns } =
    useContratoServicoService();
  const { queryParams } = useContext(QueryParamsContext);

  const handlePrintToPdf = async () => {
    const filtersDescriptions = {
      period: {
        label: "Período",
        formatedValue: (searchPeriod) => {
          const objEntries = Object.entries(periods);
          const [key] = objEntries.find(([_, value]) => value === searchPeriod);
          return key;
        },
      },
      startDate: {
        label: "Data inicial",
        formatedValue: (date) =>
          moment(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      },
      endDate: {
        label: "Data final",
        formatedValue: (date) =>
          moment(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      },

      multicompany: {
        label: "Empresa",
        formatedValue: (company) => {
          const objEntries = Object.entries(cachedCompanies);
          const companies = objEntries.find(([_, value]) => value === company);
          return companies[0] ?? queryParams?.nomeempresa;
        },
      },

      customer: {
        label: "Cliente",
        formatedValue: (customer) => {
          if (!customer) return "Todos";

          const customers = cachedClients.find(
            ({ value }) => value === customer
          );
          return customers[0] ?? queryParams?.nomeempresa;
        },
      },

      group: {
        label: "Agrupamento",
        formatedValue: (group) => {
          const objEntries = Object.entries(groupment);
          const [key] = objEntries.find(([_, value]) => value === group);
          return key;
        },
      },
      multipleSort: {
        label: "Ordenado por:",
        formatedValue: (sortFilter) => {
          const sort = JSON.parse(sortFilter);
          if (!sort.length) return "Sem ordenação";
          const sortedLabels = contractsColumns
            .filter((column) =>
              sort.find((sorted) => sorted.column === column.id)
            )
            .map((item) => item.label);
          return sortedLabels.join(", ");
        },
      },
      dateFilter: {
        label: "Data de",
        formatedValue: (dateFilter) => {
          const objEntries = Object.entries(dateType);
          const [key] = objEntries.find(([_, value]) => value === dateFilter);
          return key;
        },
      },
      status: {
        label: "Status",
        formatedValue: (statusFilter) => {
          const objEntries = Object.entries(contractStatus);
          const [key] = objEntries.find(([_, value]) => value === statusFilter);
          return key;
        },
      },
      modality: {
        label: "Modalidade",
        formatedValue: (modalityFilter) => {
          const objEntries = Object.entries(modality);
          const [key] = objEntries.find(
            ([_, value]) => value === modalityFilter
          );
          return key;
        },
      },
      number: {
        label: "Número",
        formatedValue: (contractNumber) => contractNumber || "Todos",
      },
    };

    setPrintLoading(true);

    const getGroupDescription = (group) => {
      if (group === "Sem Agrupamento") return group;

      const objEntries = Object.entries(groupment);
      const [key] = objEntries.find(([_, value]) => value === group);
      return key;
    };

    const pdfBody = {
      title: "Relatório de Contrato de Serviços",
      type: "DETALHADO",
      group: getGroupDescription(cachedContracts.data[0].group?.type),
      companyName: queryParams?.nomeempresa,
      companyFantasy: queryParams?.apelido,
      headerLogo: queryParams?.imagebase64,
      footerLogo: queryParams?.imagebase64,
      login: queryParams?.usuario_nome,
      filter: Object.entries(filters)
        .filter(([key, _]) => !!filtersDescriptions[key])
        .map(([key, value]) => ({
          field: filtersDescriptions[key].label,
          value: filtersDescriptions[key].formatedValue(value),
        })),
      movement: cachedContracts.data,
      searchPeriod: cachedContracts.period,
      total: {
        amount: 0,
        balance: 0,
        originalAmount: 0,
        debit: 0,
        debitPerCent: 0,
        credit: 0,
        creditPerCent: 0,
        increase: 0,
        discount: 0,
      },
    };
    const res = await printServiceContractPDF(pdfBody);
    setPrintLoading(false);
    if (res?.status !== 200) {
      return notify("Falha ao imprimir relatório", true, "error");
    }

    const blob = b64toBlob(res?.data?.fileBase64, "application/pdf");
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl);
  };

  return (
    <Grid item container direction="row" spacing={1}>
      <Grid item xs />
      <Grid item>
        <ExportButton
          data={cachedContracts.data}
          filename={`contrato-servicos-${Date.now()}`}
          columns={columns}
        />
      </Grid>
      <Grid item>
        <Button
          size="small"
          variant="contained"
          startIcon={printLoading ? <CircularLoader size={16} /> : <Print />}
          color="primary"
          disabled={printLoading || !cachedContracts.data.length}
          onClick={handlePrintToPdf}
        >
          {printLoading ? "Gerando relatório..." : "Imprimir"}
        </Button>
      </Grid>
    </Grid>
  );
};
